























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";

@Component
export default class ConceptNoteDeclarationComponent extends Vue {
    @Action("createConceptNote", { namespace: "conceptNote" }) createConceptNote: any;
    @Action("setConceptNote", { namespace: "ConceptNote" }) setConceptNote: any;
    @Action("setCallId", { namespace: "conceptNote" }) setCall: any;
    @Getter("getCallId", { namespace: "conceptNote" }) callId: number;
    checkboxValue: boolean = true;
    declarationContent = _app.applicantDeclarationText;
    tigerProgramId = _app.programs.tiger;

    /** mount fn */
    mounted() {
        /** get the query string to manage the redirection from login screen */
        if (this.$route.query.callId) {
            this.setCall(this.$route.query.callId);
        }
        /** if call id is not set, redirect to the calls listing page */
        if (!this.callId) {
            this.$router.push({
                name: "callForProposal"
            });
        }
    }

    /** submit declaration */
    agree() {
        if (this.callId) {
            // create new concept note and navigate to the conceptnote form
            return this.createConceptNote(this.callId)
                .then((id: any) => {
                    if (id != null) {
                        this.$router.push({
                            name: "conceptnoteapply",
                            params: { conceptNoteId: id }
                        });
                    }
                });
        }

    }

    disagree() {
        const key: any = "appDeclaration";
        this.$router.push({
            name: "genericNotification",
            query: { msgId: key },
        });
    }


}
